/**
 * Brand palette — the single JS source of truth for colors needed in
 * TypeScript / canvas contexts (where Tailwind classes can't reach).
 * Mirrors `tailwind.config.js` `colors` and the CSS variables in `index.css`.
 */
export const PALETTE = {
    primary: '#00f5ff',
    primaryDark: '#00b8c0',
    secondary: '#00ff9d',
    dark: '#0e1524',
    /**
     * Page ground per theme — mirrors `--ground` in index.css.
     * Drives `<meta name="theme-color">`, i.e. the Safari tab bar / iOS toolbar tint,
     * so browser chrome matches the page instead of seaming against it.
     * `groundDark` equals `dark` by value but not by meaning (ink surface vs themed ground).
     */
    groundDark: '#0e1524',
    groundLight: '#edf1f5',
};
